import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";

export const MARGIN_BETWEEN_CARDS = 40;
export const COLUMN_WIDTH = (MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH- 4 * MARGIN_BETWEEN_CARDS)/4;
